import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';

import 'ol/ol.css';
import './mouse_position.css';


const mousePosition = (displayProjection, target) => {
	const mousePosition = new MousePosition({
    	coordinateFormat: createStringXY(5),
        projection: displayProjection,
        target: target
    });
    
    return mousePosition;
}

export {
	mousePosition
}